import React from 'react'
import PropTypes from 'prop-types'

import { get } from 'lodash'
import Popup from 'reactjs-popup'

const booleanTranslator = {
  [true]: true,
  Yes: true,
  Datto: true,
  Commvault: true,
  PRTG: true,
  No: false,
  [false]: false,
  [null]: false
}

const ComplianceIcon = ({ boolean, trueColor, falseColor, tipContent }) => {
  const isCompliant = get(booleanTranslator, boolean, true)
  const icon = <i className={isCompliant ? `lnr lnr-check lnr-${trueColor}` : `lnr lnr-cross lnr-${falseColor}`} />
  const popupTip = (
    <Popup trigger={icon} position="bottom center" closeOnDocumentClick className="w-fit" on={['hover', 'focus']}>
      <div className='text-center'>
        {tipContent}
      </div>
    </Popup>
  )

  return (
    tipContent ? popupTip : icon
  )
}

ComplianceIcon.propTypes = {
  boolean: PropTypes.oneOf([PropTypes.bool, PropTypes.string]).isRequired,
  trueColor: PropTypes.string,
  falseColor: PropTypes.string
}

ComplianceIcon.defaultProps = {
  trueColor: 'green',
  falseColor: 'red'
}

export default ComplianceIcon
